;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();export const getQueries = (queryString: string) => {
  return queryString.slice(queryString.indexOf('?'))
}

/**
 * A function to get a query parameter as a positive number
 */
export const getPositiveNumberQueryParameter = (
  params: URLSearchParams,
  parameter: string,
  fallback: number,
) => {
  const value = Number(params.get(parameter))
  return value ? Math.abs(value) : fallback
}
